import type { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import style from './style.module.scss';

interface SlidingContentContainerProps extends ClassNameProp, PropsWithChildren {
  sliding: boolean;
}

const Container: FC<SlidingContentContainerProps> = ({ children, sliding, className }) => (
  <div className={classNames(style.slidingContentContainer, className)}>
    <div className={classNames(style.slidingContentWrapper, { [style.sliding]: sliding })}>
      {children}
    </div>
  </div>
);

const SlidingContent: FC<ClassNameProp & PropsWithChildren> & {
  Container: typeof Container;
} = ({ children, className }) => (
  <div className={classNames(style.slidingContent, className)}>{children}</div>
);

Container.displayName = 'Container';

SlidingContent.displayName = 'SlidingContent';
SlidingContent.Container = Container;

export default SlidingContent;
